import { Box, Modal } from '@mui/material';
import { useAppSelector } from 'app/hooks';
import Loader from 'components/atoms/loader';
import { selectAuth } from 'features/auth/authSlice';
import { selectChat } from 'features/auth/chatSlice';
import INftCard from 'interfaces/NftCard.interface';
import React from 'react';

import SingleUserRow from './SingleUserRow';

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '50vw',
  maxWidth: '450px',
  bgcolor: '#312F41',
  boxShadow: 24,
  p: 4,
  display: 'flex',
  flexDirection: 'column',
  gap: '20px',
};

interface IShareModalProps {
  open: boolean;
  handleClose: () => void;
  props: INftCard;
}

const ShareModal: React.FC<IShareModalProps> = ({
  open,
  handleClose,
  props,
}) => {
  const authState = useAppSelector(selectAuth);
  const user0 = require('assets/Profile/buku_default_avatar.png');
  const chatState = useAppSelector(selectChat);

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        {chatState.loading ? (
          <Loader />
        ) : authState.inboxUsers.length === 0 ? (
          <div style={{ color: 'white' }}>No data found.</div>
        ) : (
          authState.inboxUsers.map((el, index) => {
            if (el.id) {
              return (
                <SingleUserRow
                  data={props}
                  key={index}
                  userId={el.id}
                  username={el.username}
                  avatarSrc={el.avatar || user0}
                />
              );
            } else {
              return chatState.loading ? (
                <Loader key={index} />
              ) : (
                <div key={index} style={{ color: 'white' }}>No data found.</div>
              );
            }
          })
        )}
      </Box>
    </Modal>
  );
};

export default ShareModal;
